module.exports = __webpack_public_path__ + "img/undraw_images_re_0kll.aa7eb342.svg";